import React from 'react';
import numeral from 'numeral';
import { toast } from 'react-toastify';
import classnames from 'classnames';

import { smallImageUrl, } from '../shared/models/amazonProduct';
import ProductTagsDisplay from './ProductTagsDisplay';
import ProgressButton from './ProgressButton';

export default function ReceivingRequestDetail (props) {
  const { receivingRequest, productsById, } = props;
  const { items, status } = receivingRequest;
  const diffItems = items.filter(_ => _.quantity !== (_.goodInventoryIds?.length || 0) + (_.ngInventoryIds?.length || 0));
  const onClickReceived = async () => {
    if(!window.confirm('本当に入庫済みにしますか？')) return;

    try {
      await receivingRequest.ref.update({ status: 'received', isReceivedByUser: true, });
      toast.success('入庫済みにしました');
    } catch(e) {
      console.error(e);
      toast.error('失敗しました');
    }
  };

  return (
    <div>
      <div className="d-flex mb-3 justify-content-end">
        <ProgressButton disabled={status !== 'processing' || diffItems.length === 0} process={onClickReceived}>
          入庫済みにする
        </ProgressButton>
      </div>
      <table className="table sticky-table table-sm table-bordered">
        <thead className="thead-light text-center">
          <tr className="text-nowrap">
            <th style={{ minWidth: 200 }}>商品</th>
            <th style={{ minWidth: 80 }}>
              入庫依頼数
              <br />
              入庫数
              <br />
              販売不可数
            </th>
          </tr>
        </thead>
        <tbody>
          {
            items.map((item, i) => {
              const { productId, quantity, } = item;
              const goodInventoryIds = receivingRequest[`goodInventoryIds-${productId}`] || [];
              const ngInventoryIds = receivingRequest[`ngInventoryIds-${productId}`] || [];
              const product = productsById[productId];
              const isDiff = quantity !== goodInventoryIds.length + ngInventoryIds.length;
              return (
                <tr key={i} className={classnames({ 'table-danger': status === 'processing' && isDiff })}>
                  <td>
                    <ProductTagsDisplay product={product} productTags={[]} />
                    <div className="text-muted small d-flex gap-1">
                      <div>{product?.sku}</div>
                    </div>
                    <div className="d-flex align-items-start gap-1">
                      {
                        product?.isAmazonProduct && (
                          <div>
                            <img src={smallImageUrl(product?.amazonProduct)} style={{ maxHeight: 40 }} />
                          </div>
                        )
                      }
                      <div className="flex-grow-1 text-wrap">
                        <span>{product?.name}</span>
                      </div>
                    </div>
                  </td>
                  <td className="text-right">
                    <div>{numeral(quantity).format('0,0')}</div>
                    <div>{numeral(goodInventoryIds.length).format('0,0')}</div>
                    <div>{numeral(ngInventoryIds.length).format('0,0')}</div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </table>
    </div>
  );
};
